import { render } from "./TreeItem.vue?vue&type=template&id=39e5078f&scoped=true&ts=true"
import script from "./TreeItem.vue?vue&type=script&lang=ts"
export * from "./TreeItem.vue?vue&type=script&lang=ts"

import "./TreeItem.vue?vue&type=style&index=0&id=39e5078f&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e5078f"]])

export default __exports__